<div class="flex flex-col" [class.min-h-screen]="!isJobMatchesPage" [class.min-h-95vh]="isJobMatchesPage">
  <!-- Header (hidden on ai-job-matcher page) -->
  <app-header *ngIf="showHeader"></app-header>

  <!-- Main content area with semantic structure -->
  <main 
    id="main-content" 
    class="flex-1"
  >
    <router-outlet></router-outlet>
  </main>

  <!-- Footer -->
  <app-footer *ngIf="showFooter"></app-footer>

  <!-- Feedback component (hidden on mobile and on /job-matches) -->
  <app-feedback *ngIf="showFeedback" class="hidden sm:block"></app-feedback>

  <!-- Login Modal (always available) -->
  <app-login
    [visible]="showLoginModal"
    (visibleChange)="showLoginModal = $event"
    (loginComplete)="onLoginComplete($event)"
  >
  </app-login>

  <!-- Toast Container (global notifications) -->
  <app-toast-container></app-toast-container>

  <!-- Profile feature banner (bottom-left, dismissible) -->
  <app-profile-feature-banner></app-profile-feature-banner>
</div>
